import { Typography } from '@mui/material';
import React from 'react';

export default ({ text }) => {
    return <Typography fontSize={'12px'}>{text}</Typography>;
};
